import React, { useState, useEffect, useRef } from "react";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaMobile,
  FaMoneyBillWave,
  FaSearchLocation,
  FaLink
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdViewTimeline } from "react-icons/md";
import ShortListPopup from "../shortListPopup";
import { FiMenu } from "react-icons/fi";
import { backendApi } from "../../../api/apiService";
import { toast } from "react-toastify";
import { FaPencil } from "react-icons/fa6";

export default function RejectTable({
  candidates,
  formatDateToCustomFormat,
  goToEditPage,
  candidateInterview,
  jobId,
  getShortList,
  OnholdList,
  RejectList,
  RecruitList,
  StatusValues,
  userList,
  is_active
}) {
  const [showShortList, setShowShortList] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [showDropIndex, setShowDropIndex] = useState(null);

  const refDrops = useRef([]);
  useEffect(() => {
    if (showDropIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropIndex]);
  const handleClickOutside = (event) => {
    if (refDrops.current.every(ref => ref && !ref.contains(event.target))) {
      setShowDropIndex(null);
    }
  };
  const toggleDropdown = (index) => {
    setShowDropIndex(showDropIndex === index ? null : index);
  };
  const Cancel = () => {
    setShowShortList(false);
  };

  const showShortListClick = (id) => {
    setCandidateId(id);
    setShowShortList(true);
  };



  const [SelectedStatusData, setSelectedStatusData] = useState("")
  const [SelectedStatusId, setSelectedStatusId] = useState(null);
  const [ChangeStatusPopUp, setChangeStatusPopUp] = useState(false);
  const [CandidateID, setCandidateID] = useState("");

  const StatusPopUp = (id) => {
    console.log(id, "id of candidate");
    setChangeStatusPopUp(true)
    setCandidateID(id.candidate_id)
    const currentStatusName = getStatusName(id.rec_status_id);
    setSelectedStatusData(currentStatusName);
  }

  const handleStatusChange = (event) => {
    setSelectedStatusData(event.target.value);
    const selectedStatus = StatusValues.find(
      (status) => status.status_name === event.target.value
    );
    console.log("Selected selectedStatus:", selectedStatus);
    if (selectedStatus) {
      setSelectedStatusId(selectedStatus.id);
    }
  };
  const ClosePopUpStatus = () => {
    setChangeStatusPopUp(false)
  }



  //UPDATE CANDIDATE STATUS
  const UpdateCandidateStatus = () => {
    if (SelectedStatusData === "") {
      toast.warn("Please select a status", { containerId: "Z" });
      return false;
    }
    var req = {
      functionName: "changeStatusShortList",
      // sec_user_id: localStorage.getItem("userId"),
      candidate_id: CandidateID,
      job_opening_id: jobId,
      rec_status_id: SelectedStatusId,
      created_by: localStorage.getItem("userId"),

    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Status Updated Succesfully", { containerId: "Z" });
        setChangeStatusPopUp(false)
        setSelectedStatusData("");
        OnholdList();
        RejectList();
        RecruitList(); 
      } else {
        console.error("Error");
        toast.error("Error", { containerId: "Z" });
        return false;
      }
    });
  };
  const getStatusName = (rec_status_id) => {
    const matchingStatus = StatusValues.find(
      (status) => status.id === rec_status_id
    );
    return matchingStatus ? matchingStatus.status_name : "Status not found";
  };
  const currentUserId = localStorage.getItem('userId');
  const getUserRole = (userId) => {
    const user = userList.find(user => user.id === parseInt(userId, 10));
    return user ? user.role_name : null;
  };
  const currentUserRole = getUserRole(currentUserId);
  console.log(currentUserRole, "currentUserRole");




  return (
    <div className="table-scroll">
      {candidates.length > 0 ? (
        <table className="table-responsive">
          <thead style={{ height: "30px" }}>
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <th style={{ textAlign: "left", width: "250px" }}>
                Candidate Details
              </th>
              <th style={{ textAlign: "left", width: "450px" }}>Skill Set</th>
              <th style={{ textAlign: "left", width: "150px" }}>Experience</th>
              <th style={{ textAlign: "left", width: "200px" }}>Status</th>
              <th style={{ textAlign: "left", width: "200px" }}>Actions</th>
            </tr>
          </thead>
          {candidates?.map((candidateData, index) => {
            return (
              <tbody>
                <tr>
                  <td aria-label="Lead Summary">{index + 1}</td>
                  <td aria-label="Lead Summary">
                    <p className="schedule-td-head">{candidateData.full_name}</p>
                    <div className="mb-2">
                      <span className="label-text"><FaAddressBook title="address" size={12} /> </span>
                      <span className="font-Medium"> {candidateData.address || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaEnvelope title="email" size={12} /> </span>
                      <span className="font-Medium"> {candidateData.email_id || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaMobile title="Contact No:" size={12} /> </span>
                      <span className="font-Medium"> {candidateData.mobile_no || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaSearchLocation title="location" size={12} /></span>
                      <span className="font-Medium"> {candidateData.location || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaClock title="Uploaded On" size={12} /></span>
                      <span className="font-Medium"> {formatDateToCustomFormat(candidateData.candidate_created_date)}</span>
                    </div>
                  </td>
                  <td aria-label="Skills" style={{ textAlign: "left" }}>
                    {candidateData.candidate_skill_set ? (
                      candidateData.candidate_skill_set.split(",").map((loc, i) => (
                        <span className="skill-span me-1" key={i}>
                          {loc.trim()}
                        </span>
                      ))
                    ) : (
                      <span style={{ fontSize: 12 }}>NA</span>
                    )}
                  </td>
                  <td>
                    <div className="mb-2">
                      <span className="label-text"><FaAward title="experience" /></span>
                      <span className="font-Medium"> {candidateData.total_experiance}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaMoneyBillWave title="CTC" size={12} /></span>
                      <span className="font-Medium"> {candidateData.ctc || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><MdViewTimeline title="Notice Period" size={12} /></span>
                      <span className="font-Medium"> {candidateData.notice_period || "NA"}</span>
                    </div>
                    <div className="mb-2">
                      <span className="label-text"><FaLocationDot title="Preferred Location" size={12} /></span>
                      <span className="font-Medium"> {candidateData.preferredLocation || "NA"}</span>
                    </div>
                  </td>
                  {/* <td aria-label="View" style={{ textAlign: "center" }}>
                    <div className="mt-1">
                      <button
                        className="btn-theme1 w-100 m-0 h-auto"
                        onClick={() => goToEditPage(candidateData.candidate_id)}
                      >
                        Edit
                      </button>
                    </div>
                    <div className="mt-1">
                      <button
                        className="btn-theme2 w-100 m-0 h-auto"
                        onClick={() =>
                          candidateInterview(candidateData.candidate_id)
                        }
                      >
                        Schedule
                      </button>
                    </div>
                    <div className="mt-1">
                      <button
                        className="btn-theme w-100 m-0 h-auto"
                        onClick={() => {
                          showShortListClick(candidateData.candidate_id);
                        }}
                      >
                        ShortList
                      </button>
                    </div>

                  </td> */}
                  <td>
                    {currentUserRole !== "Recruiter" &&
                      currentUserRole !== 'Executive' ? (
                      <div className="d-flex align-items-center gap-3 mb-2">
                        Status: <b style={{color:"red"}}> {getStatusName(candidateData.rec_status_id)}</b>
                        <FaPencil
                          style={{ color: 'red' }}
                          onClick={() => StatusPopUp(candidateData)}
                        />
                      </div>
                    ) : null}

                    <div><span>Updated By {candidateData.rec_status_by}</span></div>
                    <div><span>On {new Date(candidateData.res_status_date).toLocaleDateString()}</span></div>
                  </td>
                  <td aria-label="View" style={{ textAlign: "center" }}>
                    <div className="mt-1 position-relative">
                      <FiMenu onClick={() => toggleDropdown(index)} size={24} />
                      <div
                        ref={el => refDrops.current[index] = el}
                        className={`dropdown-card ${showDropIndex === index ? "show" : ""}`}
                      >
                        <ul>
                          <li onClick={() => goToEditPage(candidateData.candidate_id)}>Edit</li>
                          <li onClick={() => candidateInterview(candidateData.candidate_id)}>Schedule</li>
                          <li onClick={() => showShortListClick(candidateData.candidate_id)}>ShortList</li>


                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </table>
      ) : (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4 className="errorMsg">No Candidates Rejected</h4>{" "}
        </span>
      )}
      {showShortList && (
        <ShortListPopup
          Cancel={Cancel}
          candidateId={candidateId}
          jobId={jobId}
          getShortList={getShortList}
        />
      )}

      {ChangeStatusPopUp && (
        <div
          className="modal_parent"
          id="deletesprint"
        >
          <div className="module_popup deletePeople">
            <div className="module_innerpopup module_bodypop">
              <div className="module_headdiv">
                <h4 className="popup_head"> Change Status</h4>
              </div>
              <div className="form-row">
                <label htmlFor="" className="form-label">
                  Status <span className="red ml-1">*</span>
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={SelectedStatusData}
                  onChange={handleStatusChange}
                >
                  <option value="">-Select-</option>
                  {StatusValues.filter((status) => status.is_default === 1).map((status) => (
                    <option key={status.id} value={status.status_name}>
                      {status.status_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-2 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex gap-3">
                  <button
                    type="submit"
                    className="btn btn-btn1 btn-btn"
                    onClick={UpdateCandidateStatus}
                    disabled={is_active === 0}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-btn2 btn-btn"
                    onClick={ClosePopUpStatus}
                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}
